export default __webpack_public_path__ + "static/media/section1-bg1.db38f6f3.png";